export default __webpack_public_path__ + "static/media/logo.274b37fd.png";